// Host-based portal configuration.
//
// caas-front serves two different products from the same bundle:
//   - the application portal (apply-uat.fvbank.us / apply.fvbank.us), whose
//     root "/" shows the SelectScreen landing.
//   - the broker / ramp-up portal (rampup-uat.fvbank.us, and future prod host),
//     which is broker-only — its root "/" should land straight on /broker.
//
// Any hostname containing "rampup" is treated as a broker portal — this covers
// rampup-uat.fvbank.us, rampup.fvbank.us, and any future variant without edits.
export const BROKER_PORTAL_HOST_PATTERN = /rampup|gma-onboarding/i;

// Where the broker portal sends visitors who hit the bare root "/".
export const BROKER_PORTAL_LANDING = "/broker";

// True when the current host is a dedicated broker portal.
export const isBrokerPortalHost = (hostname) => {
  const host = String(
    hostname || (typeof window !== "undefined" ? window.location.hostname : "")
  ).toLowerCase();
  return BROKER_PORTAL_HOST_PATTERN.test(host);
};
